import $ from 'jquery';
import TwitterFeed from '../components/TwitterFeed';
import InstagramFeed from '../components/InstagramFeed';

export default class DynamicSocialWidgets {
  constructor({ el }) {
    this.$el = $(el);
    if ($('[data-instagram]', this.$el).length) {
      this.instagram = new InstagramFeed({ el: this.$el });
    }
    if ($('[data-twitter]', this.$el).length) {
      this.twitter = new TwitterFeed({ el: this.$el });
    }
  }

  update($el) {
    if (this.instagram) {
      this.instagram.setElement($el);
      this.instagram.update();
    }

    if (this.twitter) {
      this.twitter.setElement($el);
      this.twitter.update();
    }
  }
}
